module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("The Michael Gray Series")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Henry Kuttner and C.L. Moore")]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/01_title"
    }
  }, [_vm._v("The Murder of Eleanor Pope")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/01_title_",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Murder of Ann Avery")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/04_title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murder of a Mistress")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/_03_title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murder of a Wife")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 60
// module chunks = 0